import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getPersonalQueriesByFaqId } from "../../../api/FAQ/Admin/PersonalFAQ/getPersonalQueriesByFaqId";
import { getQuereyByResponseQueryId } from "../../../api/FAQ/Admin/PersonalFAQ/Response/getQuereyByResponseQueryId";
import { useAuthContext } from "../../../hooks";
import PersonalSc from "./index.sc";

function Index() {
  const params = useParams();
  const auth = useAuthContext();
  const [personalQId, setPersonalQId] = useState<any>([]);
  const fetchAllAnonymousFaq = async () => {
    await getPersonalQueriesByFaqId(
      auth?.userInfo?.orgs[0]?.id,
      params?.personalFaqId
    )
      .then((e) => {
        console.log(e);
        setPersonalQId(e);
      })
      .catch((e) => console.log(e));
  };
  const [responseQuery, setResponseQuery] = useState<any>([]);
  const fetchResponseQueryId = async () => {
    await getQuereyByResponseQueryId(
      auth?.userInfo?.orgs[0]?.id,
      params?.personalFaqId
    )
      .then((e) => {
        console.log(e);
        setResponseQuery(e);
      })
      .catch((e) => console.log(e));
  };
  useEffect(() => {
    fetchAllAnonymousFaq();
    fetchResponseQueryId();
  }, []);
  return (
    <PersonalSc>
      <div className="container_reply">
        {personalQId?.map((data: any) => {
          return (
            <>
              <div className="heading">
                <div className="member_name">
                  Employee Name{""}:{""}
                  <span style={{ fontSize: "15px", margin: "10px" }}>
                    {data?.posted_by}
                  </span>
                </div>
                <div className="faq_type">
                  Created at {""}:{data?.created_at}
                </div>
              </div>
              <div className="query_content">{data?.query}</div>
            </>
          );
        })}
        <label>Response</label>
        <div className="admin_reply_container">
          {responseQuery?.map((data: any) => {
            return (
              <>
                <div>{data?.pfr_response}</div>
              </>
            );
          })}
        </div>
      </div>
    </PersonalSc>
  );
}

export default Index;
